import { Logger } from '@main/utils/logger';
import { BusIframe } from '@main/bus-layer/bus-iframe';
import type { BusEvent } from '@main/utils/bus-event-promisifier';
import { BusEventsPromisifier } from '@main/utils/bus-event-promisifier';
import type { StoreTeamListEventPublisher } from './store-teamlist.usecase';

export class StoreTeamListPublisher implements StoreTeamListEventPublisher {
  private logger: Logger;

  constructor() {
    this.logger = new Logger();
  }

  async publish(from: number): Promise<void> {
    const iframe = await BusIframe.getIframe();
    const payload = {
      variables: {
        from,
        limit: 100,
      },
    };
    const event: BusEvent = {
      type: 'API.SEARCH_TEAMS',
      payload,
    };
    this.logger.info('API.SEARCH_TEAMS:', {
      action: 'API.SEARCH_TEAMS',
      payload,
    });
    return BusEventsPromisifier.promisifySyncEvent({
      event,
      fulfilled: 'API.SEARCH_TEAMS_FULFILLED',
      target: iframe,
    });
  }
}
